import {Component, inject, signal} from '@angular/core';
import {MatList, MatListItem} from '@angular/material/list';
import {FormBuilder, ReactiveFormsModule} from '@angular/forms';
import {MatCheckbox} from '@angular/material/checkbox';
import {RouterLink} from '@angular/router';
import {MatIcon} from '@angular/material/icon';
import {FeatureFlagsService} from '../../../core/feature-flags.service';
import {MatButton} from '@angular/material/button';
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-admin-service-flags',
    imports: [MatList, ReactiveFormsModule, MatCheckbox, RouterLink, MatIcon, MatButton, MatListItem, TranslateModule],
    templateUrl: './admin-service-flags.component.html',
    styleUrl: './admin-service-flags.component.scss'
})
export class AdminServiceFlagsComponent {
  // Injections
  private readonly fb: FormBuilder = inject(FormBuilder);
  private readonly featureFlagService: FeatureFlagsService = inject(FeatureFlagsService);

  notifications = signal([]);

  form = this.fb.group({
    temporary: this.fb.group({}), experimental: this.fb.group({
      useNewObjectPage: this.featureFlagService.getFeatureFlags().experimental.useNewObjectPage,
      useNewFilterMenu: this.featureFlagService.getFeatureFlags().experimental.useNewFilterMenu,
      useNewMainMenu: this.featureFlagService.getFeatureFlags().experimental.useNewMainMenu
    }), permanent: this.fb.group({})
  })

  constructor() {
    this.featureFlagService.initFeatureFlags().then(() => {
      this.initFlags().then(() => {
        if (this.form.controls.experimental.controls.useNewMainMenu.value) {
          this.form.controls.experimental.controls.useNewObjectPage.setValue(true);
          this.form.controls.experimental.controls.useNewObjectPage.disable();
          this.form.controls.experimental.controls.useNewFilterMenu.setValue(true);
          this.form.controls.experimental.controls.useNewFilterMenu.disable();
        }
      });
    })
  }

  async initFlags() {
    const overrides = this.featureFlagService.getOverrides();
    this.form = this.fb.group({
      temporary: this.fb.group({}), experimental: this.fb.group({
        useNewObjectPage: this.featureFlagService.getFeatureFlags().experimental.useNewObjectPage, ...overrides?.experimental,
        useNewFilterMenu: this.featureFlagService.getFeatureFlags().experimental.useNewFilterMenu, ...overrides?.experimental,
        useNewMainMenu: this.featureFlagService.getFeatureFlags().experimental.useNewMainMenu, ...overrides?.experimental
      }), permanent: this.fb.group({})
    });
  }

  saveFlags() {
    this.featureFlagService.setOverrides({
      ...this.form.getRawValue()
    })
    this.notify('Lagret!');
  }

  toggleNewLayout() {
    if (this.form.controls.experimental.controls.useNewMainMenu.value) {
      this.form.controls.experimental.controls.useNewObjectPage.setValue(true);
      this.form.controls.experimental.controls.useNewObjectPage.disable();
      this.form.controls.experimental.controls.useNewFilterMenu.setValue(true);
      this.form.controls.experimental.controls.useNewFilterMenu.disable();
    }
    else {
      this.form.controls.experimental.controls.useNewObjectPage.enable();
      this.form.controls.experimental.controls.useNewFilterMenu.enable();
    }
  }

  async resetFlags() {
    this.featureFlagService.clearOverrides();
    this.initFlags();
    this.notify('Flagg tilbakestilt')
  }

  private notify(message: string) {
    const id = (Math.random() * 100).toString(16)
    const notification = {
      id,
      message
    }
    this.notifications.update(arr => [...arr, notification])
    setTimeout(() => {
      this.notifications.update(arr => arr.filter(n => n.id !== id))
    }, 3000)
  }
}
